import type { AppThemeColors } from './emotion';

export const darkTheme: AppThemeColors = {
  background: '#1f1633',
  surface: '#2a1f3d',
  surfaceElevated: '#362d59',
  surfaceGlass: 'rgba(255, 255, 255, 0.18)',
  surfaceDeep: '#150f23',
  text: '#ffffff',
  textSecondary: '#e5e7eb',
  textMuted: '#79628c',
  border: '#362d59',
  borderLight: '#584674',
  borderInput: '#cfcfdb',
  primary: '#6a5fc1',
  primaryHover: '#7b71d1',
  primaryText: '#ffffff',
  buttonBg: '#79628c',
  buttonBorder: '#584674',
  accentLime: '#c2ef4e',
  accentCoral: '#ffb287',
  accentPink: '#fa7faa',
  sidebarBg: '#150f23',
  sidebarText: '#e5e7eb',
  sidebarActiveText: '#c2ef4e',
  sidebarActiveBg: '#422082',
  sidebarHoverBg: '#2a1f3d',
  topbarBg: '#150f23',
  topbarText: '#ffffff',
  topbarBorder: '#362d59',
  overlay: 'rgba(21, 15, 35, 0.8)',
  error: '#ef4444',
  errorMuted: '#3d1a2a',
  success: '#22c55e',
  successMuted: '#1a3d2a',
  warning: '#f59e0b',
  warningMuted: '#3d2a1a',
  info: '#6a5fc1',
  infoMuted: '#2a1f3d',
};
